import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useSelector} from 'react-redux';
import Auth from "../../Helper/Auth";
import userInfo from '../UserInfo';


export default function AdminHome(){ 
  

  const navigation = useNavigate();
  let loggedUser = useSelector(store => store.user['user'])
  
  return(
    <section className="admin-home" >
   <div className='extra-space-t'></div>
    <div className='container'>
      <div className='row'>
        <div className='col-lg-3 col-sm-6 col-12'>
          <Link to='/list'>
            <div className="card middle-aln">
              <h1>Exhibitor Account List</h1>                
            </div> 
          </Link>          
        </div>
        <div className='col-lg-3 col-sm-6 col-12'>
          <Link to='/eventlist'>
            <div className="card middle-aln">
              <h1>Events</h1>                
            </div>  
          </Link>          
        </div>
        <div className='col-lg-3 col-sm-6 col-12'>
          <Link to='/admin-subscription'>
            <div className="card middle-aln">
              <h1>subscriptions</h1>                
            </div>    
          </Link>        
        </div>
        <div className='col-lg-3 col-sm-6 col-12'>
          <Link to='/galleryreviews'>
            <div className="card middle-aln">
              <h1>Gallery Reviews</h1>                
            </div> 
          </Link>           
        </div>
      </div>
    </div>
     <div className='extra-space-b'></div>
  </section>  
  )
}
